export const publishedPortalStoreKey = 'publishedPortal';
